<template>
  <div class="pega-table grid-x margin-bottom-1">
    <div class="cell title">
      {{ title }}<slot name="title" />
    </div>
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    }
  }
}
</script>
